<div class="selector" [ngClass]="{'selector_selected': data?.id === selected?.id}" (click)="onClickSelect()">
    <span class="selector__icon {{data?.icon}}" [style.width.px]="data?.description ? 35 : 50" [style.height.px]="data?.description ? 35 : 50"></span>
    <div class="selector__label">{{data?.label}}</div>
    <div class="selector__description" *ngIf="data?.description">{{data?.description}}</div>
</div>